import {useState} from "react";

interface PodcastIframeProps {
    src: string;
    singleIframe?: boolean;
}

export default function PodcastIframe({ src, singleIframe = false }: PodcastIframeProps) {
    const [loaded, setLoaded] = useState(false);

    const heightClass = singleIframe
        ? "h-[180px]"
        : "h-[350px] md:h-[400px]";

    return (
        <div className={`my-4 podcast-block ${singleIframe ? "max-w-4xl" : "max-w-6xl mx-auto"}`}>
            {!loaded && (
                <div className={`mb-2 w-full animate-pulse rounded-xl bg-gradient-to-br from-gray-100 to-gray-200 dark:from-neutral-800 ${heightClass}`} />
            )}

            <iframe
                src={src}
                title="Kosmos 94.1 Gesprekke (Podcasts)"
                loading="lazy"
                onLoad={() => setLoaded(true)}
                className={`w-full rounded-xl transition-opacity duration-300 ${heightClass} ${loaded ? "opacity-100" : "opacity-0"}`}
                allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; fullscreen"
                referrerPolicy="no-referrer"
            />
        </div>
    );
}
